import "./AIResultsModal.scss";

import Button from "components/Button/Button";
import Card from "components/Card/Card";
import KaboodleModal from "components/Modals/KaboodleModal";
import { formatCurrency } from "utils/format-utils";

import type { AILienAnalysis } from "../LienTypes";

type AIResultsModalProps = {
  isOpen: boolean;
  onClose: () => void;
  analysis: AILienAnalysis;
  lienId: number;
  levelOfAppeal: string;
};

const AIResultsModal = ({
  isOpen,
  onClose,
  analysis,
  levelOfAppeal,
}: AIResultsModalProps) => {
  const hasMismatch = analysis.payment_amount_mismatch;

  return (
    <KaboodleModal
      isOpen={isOpen}
      onClose={onClose}
      footer={
        <div className="flex jc-c">
          <Button onClick={onClose}>Close</Button>
        </div>
      }
    >
      <Card heading="AI Results Analysis">
        <div className="ai-description">
          <span
            className={`material-icons ${hasMismatch ? "error" : "success"}`}
          >
            {hasMismatch ? "error" : "check_circle"}
          </span>
          {hasMismatch ? (
            <p>
              There's a discrepancy between the total payment amount and the sum
              of itemized payments for this {levelOfAppeal} lien analysis.
            </p>
          ) : (
            <p>
              Payment amounts have been verified for this {levelOfAppeal} lien
              analysis.
            </p>
          )}
        </div>

        <div className="ai-amount-row">
          <label>Total Payment Amount:</label>
          <span>
            {formatCurrency(analysis.conditional_payment_amount || 0)}
          </span>
        </div>

        <div className="ai-amount-row">
          <label>Sum of Itemized Payments:</label>
          <span>
            {formatCurrency(analysis.conditional_payment_items_sum || 0)}
          </span>
        </div>

        {hasMismatch && (
          <div className="ai-amount-row difference">
            <label>Difference:</label>
            <span className="error-amount">
              {formatCurrency(
                Math.abs(
                  (analysis.conditional_payment_amount || 0) -
                    (analysis.conditional_payment_items_sum || 0),
                ),
              )}
            </span>
          </div>
        )}

        {hasMismatch && (
          <div className="ai-recommendation">
            <strong>Recommended Action:</strong>
            Review the lien itemization chart below against the source documents
            to identify any incorrect OCR data.
          </div>
        )}

        {!hasMismatch && (
          <div className="ai-info">
            <strong>Recommended Action:</strong>
            No action is required. The payment amounts match correctly.
          </div>
        )}
      </Card>
    </KaboodleModal>
  );
};

export default AIResultsModal;
